<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p12"><span><a href="#/Contents#rp12">BASIC VEGETABLE STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>As vegetables used in stocks are later discarded, they should be scrubbed but do not need to be peeled.</i></span></p>
<p class="make"><span>Makes about 2 quarts</span></p>
<p class="hang"><span>1 each: thickly sliced large onion, leek (white part only), carrot, rib celery</span></p>
<p class="hang"><span>8 cups water</span></p>
<p class="hang"><span>1 cup dry white wine or water</span></p>
<p class="hang"><span>4 cups mixed chopped vegetables (broccoli, green beans, cabbage, potatoes, tomatoes, summer or winter squash, bell peppers, mushrooms, etc.)</span></p>
<p class="hang"><span>6–8 parsley sprigs</span></p>
<p class="hang"><span>1 bay leaf</span></p>
<p class="hang"><span>4 whole allspice</span></p>
<p class="hang"><span>1 tablespoon black peppercorns</span></p>
<p class="hang"><span>2 teaspoons dried bouquet garni</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Sauté onion, leek, carrot, and celery in lightly greased large saucepan 5 minutes; add remaining ingredients, except salt and pepper, and heat to boiling. Reduce heat and simmer, covered, 1½ to 2 hours. Strain stock, discarding vegetables and seasonings; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 4</span></p>
<p class="per1"><span>% calories from fat: 3</span></p>
<p class="per1"><span>Protein (g): 0.1</span></p>
<p class="per1"><span>Carbohydrate (g): 1</span></p>
<p class="per1"><span>Fat (g): 0.0</span></p>
<p class="per1"><span>Saturated fat (g): 0.0</span></p>
<p class="per1"><span>Cholesterol (mg): 0.0</span></p>
<p class="per1"><span>Sodium (mg): 3</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0112.vue?6b2e2741